/* eslint-disable max-len */
import React from 'react';
import '../styles.scss';
  

const SelectedCard = ({data, fetchUpdateNotification}) => {
  return (
    <>
      {
        data.map((line, indexi) => {
          return (
            <div key={indexi} className='priorization-selected-card-container'
              style={{
                'overflowY': 'scroll',
                'maxHeight': '400px', // Limita la altura del contenedor
                'border': '1px solid #ddd',
                'padding': '10px',
                'borderRadius': '5px',
                'backgroundColor': '#fff',
              }}
            >
              <table cellPadding="0" cellSpacing="0" className='priorization-selected-card-table'>
                <tbody>
                  <tr key={indexi}>
                    <div
                      className='priorization-selected-card-delete pointer'
                      onClick={() => fetchUpdateNotification(line.secuential)}
                    >
                                  &times;
                    </div>
                    <tr><span style={{'fontSize': '30px;', 'fontWeight': 'bold'}}>{line.model} - {line.color}
                    </span></tr>
                    <tr><span style={{'fontSize': '30px;'}}>LÍNEA {line.priorizationLine} DEL PEDIDO {line.priorizationOrder}  DEL CONCESIONARIO {line.priorizationReserved} CHASIS {line.priorizationChassis} DÍAS DE ANTIGUEDAD {line.priorizationOldDays}
                    </span></tr>
                    <tr><div className='priorization-selected-card-first-item' style={{'fontWeight': 'bold'}}>CAMBIAR POR</div></tr>
                    <tr><span>LÍNEA {line.sugestedLine} DEL PEDIDO {line.sugestedOrder} DEL CONCESIONARIO {line.sugestedReserved} CHASIS {line.sugestedChassis} DÍAS DE ANTIGUEDAD {line.sugestedOldDays}
                    </span></tr>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        }
        )
      }
    </>
  );
};

export default SelectedCard;
